module.exports = __webpack_public_path__ + "img/send-archive.939f530d.svg";